<template>
  <div class="main-content">

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Излишки</h5>
          </div>
          <div class="card-body">
            <div class="flex justify-content-between">
              <div class="input-group">
                <multiselect
                  name="stores"
                  class="multiselect"
                  v-model="selectedStores"
                  :noShotCuts="true"
                  :options="sortedStores"
                  placeholder="Выберите склады"
                  track-by="title"
                  label="title"
                  :showLabels="false"
                  :searchable="true"
                  :multiple="true">
                </multiselect>

                <div class="input-group-append">
                  <vue-ladda
                    @click="showOverStore()"
                    button-class="btn btn-info"
                    data-style="zoom-in"
                    :loading="btn_loading"
                  >Показать излишки
                  </vue-ladda>
                </div>
              </div>
            </div>

            <div class="alert alert-dark p-2 mt-1">
              <p>Предараты для игнорирования</p>
              <DrugSearchNew
                ref="searchDrug"
                :onSelect="(d) => addIgnoredDrug(d)"
              />
              <div class="flex justify-content-between hover mt-1" v-for="(drug,id) in ignoredDrugs">
                <span>{{ drug.title }}</span>
                <button @click="removeIgnoredDrug(id)" type="button" class="btn btn-default btn-xs"><i
                  class="icon-fa icon-fa-remove"/></button>
              </div>
            </div>

            <div class="text-right mt-2"
                 v-if="Object.keys(storeDetails).length && Object.keys(storeDetails).length > 1 && allowToSendAll">
              <LoadingButton
                title="Создать накладные для всех складов"
                className="btn btn-success"
                :onClick="() => createAllInvoice()"
                :loading="exportLoading"
              />
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="flex flex-wrap">
          <div class="card item" v-for="store in getSelectedStores()"
               v-if="(loadingDetails[store.id] || storeDetails[store.id]) && !sendInvoices[store.id]">
            <div class="card-header">
              <div class="flex justify-content-between">
                <div>
                  <strong>{{ $AllStores[store.id]?.title ?? store.id }}</strong>
                </div>
                <div class="flex justify-content-end" v-if="!loadingDetails[store.id]">
                  <LoadingButton
                    title="XLS"
                    className="btn btn-outline-info mr-1"
                    :onClick="() => exportXLS(store.id)"
                    :loading="exportLoading"
                  />
                  <LoadingButton
                    v-if="!storeDetails[store.id].collectingInvoices || !storeDetails[store.id].collectingInvoices.length"
                    title="Создать накладную перемещения"
                    className="btn btn-success"
                    :onClick="() => createNewInvoice(store.id)"
                    :loading="exportLoading"
                  />
                </div>
              </div>
            </div>
            <div class="card-body">
              <pulse-loader :loading="loadingDetails[store.id]" :color="$constants.LOADING_COLOR" class="text-center"/>
              <template v-if="storeDetails[store.id] && storeDetails[store.id].drugs">
                <div class="flex justify-content-between mt-1 mb-2">
                  <div
                    v-if="storeDetails[store.id].invoiceInUse.in && Object.keys(storeDetails[store.id].invoiceInUse.in).length"
                  >
                    Учитывать накладные поступления на склад:
                    <div>
                      <div
                        class="mb-1"
                        v-for="(inv, ind) in getInvoiceList(storeDetails[store.id].invoiceInUse.in)"
                        :key="ind.id"
                      >
                        <input
                          v-model="countIncomes[store.id][inv.id]"
                          type="checkbox"
                        />
                        <strong>{{ inv.id }}</strong>
                        <button @click="showInvoice(inv.id)" class="btn btn-xs btn-info newWindowBtn">
                          <i class="icon-fa icon-fa-eye"></i>
                        </button>
                        <button
                          @click="mixinGoToRouter('InvoicesEdit', { id: inv.id })"
                          class="btn btn-xs btn-success"
                        >
                          Открыть
                        </button>
                        <button
                          @click="openInNewPage('InvoicesEdit', { id: inv.id })"
                          class="btn btn-xs btn-success newWindowBtn"
                        >
                          <i class="icon-fa icon-fa-external-link"></i>
                        </button>
                        ({{ invoiceStatuses[inv.status] }})
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="storeDetails[store.id].invoiceInUse.out && Object.keys(storeDetails[store.id].invoiceInUse.out).length"
                  >
                    Накладные отправления с текщего склада:
                    <div>
                      <div
                        v-for="(inv, ind) in getInvoiceList(storeDetails[store.id].invoiceInUse.out)"
                        :key="ind.id"
                      >
                        <strong>{{ inv.id }}</strong>
                        <button
                          @click="mixinGoToRouter('InvoicesEdit', { id: inv.id })"
                          class="btn btn-xs btn-success"
                        >
                          Открыть
                        </button>
                        <button
                          @click="openInNewPage('InvoicesEdit', { id: inv.id })"
                          class="btn btn-xs btn-success newWindowBtn"
                        >
                          <i class="icon-fa icon-fa-external-link"></i>
                        </button>
                        ({{ invoiceStatuses[inv.status] }})
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="storeDetails[store.id].collectingInvoices && storeDetails[store.id].collectingInvoices.length">
                    Накладные на сборке:
                    <div v-for="inv in storeDetails[store.id].collectingInvoices">
                      <strong>{{ inv.id }}</strong>
                      <button @click="showInvoice(inv.id)" class="btn btn-xs btn-info newWindowBtn">
                        <i class="icon-fa icon-fa-eye"></i>
                      </button>
                      <button
                        @click="mixinGoToRouter('InvoicesEdit', { id: inv.id })"
                        class="btn btn-xs btn-success"
                      >
                        Открыть
                      </button>
                      <button
                        @click="openInNewPage('InvoicesEdit', { id: inv.id })"
                        class="btn btn-xs btn-success newWindowBtn"
                      >
                        <i class="icon-fa icon-fa-external-link"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <DrugList
                  :figures="storeDetails[store.id].drugFigures"
                  :drugs="storeDetails[store.id].drugs"
                  :ignoredDrugs="ignoredDrugs"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import StoreSelect from "@/views/admin/components/StoreSelect";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton";
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import Export2Excel from "@/Export2Excel";
import DrugList from "@/views/admin/autolists/components/DrugList";
import Multiselect from 'vue-multiselect'

export default {
  components: {
    StoreSelect,
    VueLadda,
    LoadingButton,
    DrugSearchNew,
    DrugList,
    Multiselect,
  },
  data() {
    return {
      ignoreStores: [1, 2, 3, 4],
      sendInvoices: {},
      modalChangeQtyData: null,
      sortedStores: [],
      invoiceStatuses: {
        2: 'в дороге',
        1: 'предварительная'
      },
      exportLoading: false,
      upload_loading: false,
      countIncomes: {},
      btn_loading: false,
      selected_store: null,
      uploaded_store: null,
      store_name: null,
      drugs: [],
      preps: {},
      exportTypes: null,
      exportType: "xlsx",
      invoiceInUse: {},
      collectingInvoices: [],
      ignoredDrugs: {},
      storeDetails: {},
      loadingDetails: {},
      selectedStores: [],
      allowToSendAll: false,
    };
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  mounted() {
    this.exportTypes = Export2Excel.formats;
    let stores = [];
    stores.push({title: 'Все МСК', group: 'msk'});
    stores.push({title: 'Регионы', group: 'regions'});
    // stores.push(this.$AllStores[3]);
    // stores.push(this.$AllStores[10]);
    stores = [...stores, ...(_.orderBy(Object.values(this.$AllDivisions).reduce((acc, d) => {
      if (d.is_active && +d?.stores?.[0]?.object_id && !this.ignoreStores.includes(+d?.stores?.[0]?.object_id)) {
        acc.push({id: +d.stores[0].object_id, title: d.title, cities_ids: d.cities.map((c) => c.object_id)})
      }
      return acc;
    }, []), 'title'))];
    // stores = [...stores, ...(_.orderBy(Object.values(this.$AllStores).filter((s) => ![1, 2, 3, 4, 10, 30].includes(s.id) && s.is_active), 'title'))];
    this.sortedStores = stores;
    this.selected_store = 3;
  },
  methods: {
    getSelectedStores() {
      return this.selectedStores.reduce((acc, s) => {
        if (this.ignoreStores.includes(+s.id)) return acc;
        switch (s.group) {
          case 'regions':
            acc = {
              ...acc, ...this.sortedStores.reduce((sAcc, ss) => {
                if (ss.group || this.ignoreStores.includes(+ss.id)) return sAcc;
                if (!(ss?.cities_ids ?? []).includes(1)) {
                  sAcc[ss.id] = {...ss};
                }
                return sAcc
              }, {})
            };
            break;
          case 'msk':
            acc = {
              ...acc, ...this.sortedStores.reduce((sAcc, ss) => {
                if (ss.group || this.ignoreStores.includes(+ss.id)) return sAcc;
                if ((ss?.cities_ids ?? []).includes(1)) {
                  sAcc[ss.id] = {...ss};
                }
                return sAcc
              }, {})
            };
            break;
          default:
            acc[s.id] = {...s};
            break;
        }
        return acc;
      }, {})
    },
    removeIgnoredDrug(id) {
      this.$delete(this.ignoredDrugs, id);
    },
    addIgnoredDrug(d) {
      this.$set(this.ignoredDrugs, d.id, d)
      this.$refs.searchDrug.drug = null;
    },
    async exportXLS(storeId) {
      if (this.exportLoading) return;
      this.exportLoading = true;
      try {
        const {data} = await api.post('/excel/autoList', {
          filter: 1,
          fileTitle: 'Излишки ' + this.$AllStores[storeId].title + ' ' + moment().format('DD.MM.YYYY HH:mm'),
          drugs: _.orderBy(this.storeDetails[storeId].drugs, 'title').reduce((acc, d) => {
            acc.push({
              title: d.title,
              cool: d.cool,
              pack_comment: d.pack_comment,
              pack_box_comment: d.pack_box_comment,
              pack_set: d.pack_set,
              qty: this.storeDetails[storeId].drugFigures[d.id],
              new_qty: d.new_qty,
              invoice_comment: d.comment
            })
            return acc;
          }, [])
        });
        if (data.success) {
          window.location.href = data.link;
        } else {
          toastr['warning'](data.message || 'Ошибка сервера', 'Ошибка!');
        }
      } catch (e) {
        toastr['warning'](e.message, 'Ошибка!');
      }
      this.exportLoading = false;
    },
    async createAllInvoice() {
      for (let s of this.selectedStores) {
        if (!this.storeDetails[store.id].collectingInvoices || !this.storeDetails[store.id].collectingInvoices.length) {
          await this.createNewInvoice(s.id, false)
        }
      }
      this.sendInvoices = this.selectedStores.reduce((acc, s) => {
        acc[s.id] = true;
        return acc;
      }, {});
    },
    async createNewInvoice(storeId, redirect = true) {
      if (this.exportLoading) return;
      this.exportLoading = true;
      const {data} = await api.post('invoices/createByData', {
        invoice_comment: 'Автоматическое создание накладной излишков',
        drugs: this.storeDetails[storeId].drugs.reduce((acc, d) => {
          if (this.ignoredDrugs[d.id]) return acc;
          acc.push({
            drug_id: d.id,
            qty: d.new_qty,
            comment: d.comment
          })
          return acc;
        }, []),
        status: 4,
        store_out: storeId,
        store_in: 3,
      })
      if (data.success) {
        // if (redirect) {
        this.sendInvoices[storeId] = true;
        this.sendInvoices = {...this.sendInvoices};
        // this.mixinGoToRouter('InvoicesEdit', {id: data.invoice.id})
        // return;
        // }
        toastr['success'](`Накладная ${this.$AllStores[storeId].title} склада создана`);
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.exportLoading = false;
    },
    getInvoiceList(invoices) {
      return Object.keys(invoices).reduce((acc, drugId) => {
        Object.keys(invoices[drugId]).forEach(k => {
          if (k !== "total") {
            acc[invoices[drugId][k].invoice] = {id: invoices[drugId][k].invoice, status: invoices[drugId][k].status};
          }
        });
        return acc;
      }, {});
    },
    async showOverStore() {
      if (!this.selectedStores || !this.selectedStores.length) return;
      this.allowToSendAll = false;
      this.btn_loading = true;
      const selectedStores = this.selectedStores.reduce((acc, s) => {
        switch (s.group) {
          case 'regions':
            acc = {
              ...acc, ...this.sortedStores.reduce((sAcc, ss) => {
                if (!ss.group && !(ss?.cities_ids ?? []).includes(1) && !this.ignoreStores.includes(+ss.stores?.[0]?.object_id)) {
                  sAcc[ss.id] = true;
                }
                return sAcc
              }, {})
            };
            break;
          case 'msk':
            acc = {
              ...acc, ...this.sortedStores.reduce((sAcc, ss) => {
                if (!ss.group && (ss?.cities_ids ?? []).includes(1) && !this.ignoreStores.includes(+ss.stores?.[0]?.object_id)) {
                  sAcc[ss.id] = true;
                }
                return sAcc
              }, {})
            };
            break;
          default:
            acc[s.id] = true;
            break;
        }
        return acc;
      }, {})

      this.loadingDetails = {...selectedStores};
      this.storeDetails = {...this.loadingDetails};

      await Object.keys(selectedStores).forEach(async (sId) => {
        const {data} = await api.store("/autolists/getoverstore", {
          store_id: +sId,
          countIncomes: Object.keys(this.countIncomes[sId] || {}).filter((i) => this.countIncomes[sId][i])
        });
        if (data.success) {
          this.storeDetails[sId] = {
            drugFigures: data.figures,
            drugs: data.preps.reduce((acc, d) => {
              acc.push({...d, comment: null, new_qty: data.figures[d.id]})
              return acc;
            }, []),
            invoiceInUse: data.invoices,
            collectingInvoices: data.collectingInvoices,
          }
          if (!this.countIncomes[sId]) {
            this.countIncomes[sId] = {};
          }
          this.sendInvoices[sId] = false;
          this.sendInvoices = {...this.sendInvoices};
          this.loadingDetails[sId] = false;
          this.btn_loading = !!Object.values(this.loadingDetails).find((l) => l);
          if (!this.btn_loading) this.allowToSendAll = true;
        } else {
          toastr["warning"](`Ошибка просчета склада ${sId}`);
        }
      })
      return;
      // this.invoiceInUse = {};
      // this.preps = data.figures;
      // this.drugs = data.preps.reduce((acc, d) => {
      //   acc.push({...d, comment: null, new_qty: this.preps[d.id]})
      //   return acc;
      // }, []);
      // this.invoiceInUse = data.invoices;
      // this.collectingInvoices = data.collectingInvoices;
      // this.btn_loading = false;
      // this.uploaded_store = this.selected_store;
      // this.details = true;
    },
    showInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
  }
};
</script>

<style scoped>
.item {
  flex: 1 1 50%;
}

.hover:hover {
  background-color: #dddddd;
}

.multiselect {
  width: calc(100% - 170px);
}

.btn.ladda-button {
  padding: 4px 17px;
}
</style>
